<template>
  <alert-list />
  <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div>
        <img class="mx-auto h-12 w-auto" src="https://firebasestorage.googleapis.com/v0/b/gravy-rs-interface-staging.appspot.com/o/assets%2F5f7e2923c2413bd2d450991f_logo-green%203.svg?alt=media&token=aff71ee6-c2ea-4fd3-a6c8-98a061314976" alt="Workflow" />
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Sign in to your account
        </h2>
        <button @click.prevent="handleLogin" class="mt-5">
          <img src="https://firebasestorage.googleapis.com/v0/b/gravy-rs-interface-staging.appspot.com/o/assets%2FGroup%201542.svg?alt=media&token=fd5f5bfe-6735-4134-a5b3-e8da959f16fd">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { LockClosedIcon } from '@heroicons/vue/solid'
import firebase from "firebase";
import gravyAxios from "@/plugins/axios"
import AlertList from "@/components/Alerts/AlertList";

export default {
  components: {
    LockClosedIcon,
    AlertList,
  },
  methods: {
    googleAuthProvider() {
      return new firebase.auth.GoogleAuthProvider();
    },
    async handleLogin() {
      const provider = this.googleAuthProvider()
      await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      const signInResult = await firebase.auth().signInWithPopup(this.googleAuthProvider())
      const idToken = await signInResult.user.getIdToken()
      localStorage.setItem('gravyauth', idToken)
      gravyAxios.defaults.headers.common['Authorization'] = `Bearer: ${idToken}`
      try {
        const loginResult = gravyAxios.post('/user/login')
        await this.$router.push({name: "Send Email"})
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e.response.data.errors.join("<br/>")
        })
      }

    }
  }
}
</script>
